import { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../config/axios";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  // Initialize isLoggedIn based on localStorage
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    const user = localStorage.getItem("loggedInUser");
    return !!user; // true if user exists, false otherwise
  });

  const signOut = async () => {
    try {
      await axios.post("/auth/signout"); // backend route

      setIsLoggedIn(false);

      // Preserve only loaderShownDate and discountCoupons
      const loaderShownDate = localStorage.getItem("loaderShownDate");
      const discountCoupons = localStorage.getItem("discountCoupons");

      localStorage.clear();

      if (loaderShownDate)
        localStorage.setItem("loaderShownDate", loaderShownDate);
      if (discountCoupons)
        localStorage.setItem("discountCoupons", discountCoupons);

      // Redirect to login/home page
      navigate("/");
    } catch (error) {
      console.error("Sign out failed:", error);
    }
  };

  // Optional: sync isLoggedIn if localStorage changes externally
  useEffect(() => {
    const handleStorageChange = () => {
      const user = localStorage.getItem("loggedInUser");
      setIsLoggedIn(!!user);
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  return (
    <AuthContext.Provider value={{ isLoggedIn, setIsLoggedIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
